export default __webpack_public_path__ + "static/media/295.edaedf4d.png";